export const ALL_COLUMNS = [
  {
    value: "Session Name",
    labelKey: "name",
  },
  {
    value: "Sport Name",
    labelKey: "sportName",
  },
  {
    value: "Session Period",
    labelKey: "sessionPeriod",
  },
  {
    value: "Weekly Days",
    labelKey: "weeklyDays",
  },
  {
    value: "Total Session",
    labelKey: "totalSession",
  },
  {
    value: "Completed Sessions",
    labelKey: "completedSessions",
  },
  {
    value: "Court Name",
    labelKey: "courtName",
  },
  {
    value: "Attendees Limit",
    labelKey: "attendeesLimit",
  },
  {
    value: "Current Attendees",
    labelKey: "currentAttendees",
  },
  {
    value: "Status",
    labelKey: "sessionStatus",
  },
  {
    value: "Coach Name",
    labelKey: "coachName",
  },
];

export const initialColumns = [
  {
    Header: "Session Name",
    accessor: "name",
  },
  {
    Header: "Sport Name",
    accessor: "sportName",
  },
  {
    Header: "Session Period",
    accessor: "sessionPeriod",
  },
  {
    Header: "Weekly Days",
    accessor: "weeklyDays",
  },
  {
    Header: "Total Session",
    accessor: "totalSession",
  },
  {
    Header: "Completed Sessions",
    accessor: "completedSessions",
  },
  {
    Header: "Court Name",
    accessor: "courtName",
  },
  {
    Header: "Attendees Limit",
    accessor: "attendeesLimit",
  },
  {
    Header: "Current Attendees",
    accessor: "currentAttendees",
  },
  {
    Header: "Status",
    accessor: "sessionStatus",
  },
  {
    Header: "Coach Name",
    accessor: "coachName",
  },
];

export const countDays = (
  startDate: Date,
  endDate: Date,
  dayOfWeek: number
) => {
  // Initialize a count variable
  let dayCount: number = 0;

  // Loop through each day in the time period
  for (
    let date: Date = startDate;
    date <= endDate;
    date.setDate(date.getDate() + 1)
  ) {
    // Check if the current day is the desired day of the week
    if (date.getDay() === dayOfWeek) {
      dayCount++;
    }
  }

  // Return the number of days
  return dayCount;
};

export const countWeeks = (startDate: Date, endDate: Date): number => {
  const millisecondsPerWeek = 7 * 24 * 60 * 60 * 1000;

  const startDateTime = startDate.getTime();
  const endDateTime = endDate.getTime();

  const timeDifference = endDateTime - startDateTime;

  return Math.ceil(timeDifference / millisecondsPerWeek);
};
